import { User } from 'interfaces/user'
import { Card, Col, Collapse } from 'react-bootstrap'
import { useState } from 'react'

const UserSubscriptionCard = ({ user }: { user: User }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  // Determine if user has individual subscription
  const hasIndividualSubscription =
    user?.subscription_kind || user?.subscription_status || user?.stripe_user_id

  // Don't render the card if no subscription exists
  if (!hasIndividualSubscription) {
    return null
  }

  return (
    <Col md="12">
      <Card className="mt-3">
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: 'pointer' }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h4 className="mb-0">User Subscription</h4>
          <ion-icon
            name={isExpanded ? 'chevron-up-outline' : 'chevron-down-outline'}
            style={{
              fontSize: '20px',
              color: '#4da6ff',
              transition: 'transform 0.2s ease',
            }}
          />
        </Card.Header>

        <Collapse in={isExpanded}>
          <div>
            <Card.Body>
              {/* Linq Pay Account */}
              {user?.stripe_user_id && (
                <div className="mb-3">
                  <div
                    className="fw-bold mb-1"
                    style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}
                  >
                    Linq Pay Account
                  </div>
                  <div>
                    <a
                      href={`https://dashboard.stripe.com/connect/accounts/${user.stripe_user_id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#10B981', textDecoration: 'underline' }}
                    >
                      {user.stripe_user_id}
                    </a>
                  </div>
                </div>
              )}

              {/* Subscription Kind */}
              {user?.subscription_kind && (
                <div className="mb-3">
                  <div
                    className="fw-bold mb-1"
                    style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}
                  >
                    Linq Subscription Kind
                  </div>
                  <div>{user.subscription_kind}</div>
                </div>
              )}

              {/* Subscription Status */}
              {user?.subscription_status && (
                <div className="mb-3">
                  <div
                    className="fw-bold mb-1"
                    style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}
                  >
                    Linq Subscription Status
                  </div>
                  <div>{user.subscription_status}</div>
                </div>
              )}

              {/* Subscription Tier */}
              {(user?.is_pro_plus || user?.is_pro) && (
                <div className="mb-3">
                  <div
                    className="fw-bold mb-1"
                    style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}
                  >
                    Linq Subscription Tier
                  </div>
                  <div>{user?.is_pro_plus ? 'Pro Plus ➕' : 'Pro'}</div>
                </div>
              )}

              {/* Subscription ID */}
              {user?.subscription_id && (
                <div className="mb-3">
                  <div
                    className="fw-bold mb-1"
                    style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}
                  >
                    Linq Subscription ID
                  </div>
                  <div>
                    {user?.subscription_kind === 'stripe' ? (
                      <a
                        href={`https://dashboard.stripe.com/subscriptions/${user.subscription_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#10B981',
                          textDecoration: 'underline',
                        }}
                      >
                        {user.subscription_id}
                      </a>
                    ) : (
                      <span>{user.subscription_id}</span>
                    )}
                  </div>
                </div>
              )}
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </Col>
  )
}

export default UserSubscriptionCard
